<template>

  <div class="company-main">

    <img :src="images.logo" class="company-main-logo" />

    <div class="company-main-title">
      {{ company.title }}
    </div>

    <div class="company-main-desc">
      {{ company.desc }}
    </div>

    <div style="color: white; font-size: 20px; position: relative; left: 40%; top: 30%; opacity: 0.8"
      @click="showDialog = true">
      查看海报
    </div>

    <PosterDialog :imgUrl="company.imgUrl" v-if="showDialog" :closeDialog="closeDialog" />
  </div>
</template>

<script>

import { toRefs, reactive } from "vue";

import PosterDialog from "@/components/PosterDialog";

import ImageLogo from "@/assets/images/logo.png";
import Poster1 from "@/assets/images/poster/1.jpg";
import Poster2 from "@/assets/images/poster/2.jpg";
import Poster3 from "@/assets/images/poster/3.jpg";
import Poster4 from "@/assets/images/poster/4.jpg";
import Poster5 from "@/assets/images/poster/5.jpg";
import Poster6 from "@/assets/images/poster/6.jpg";
import Poster7 from "@/assets/images/poster/7.jpg";
import Poster8 from "@/assets/images/poster/8.jpg";
import Poster9 from "@/assets/images/poster/9.jpg";

export default {
  name: "VCompany",
  components: {
    PosterDialog
  },
  setup() {

    const state = reactive({
      company: {
      },
      images: {
        logo: ImageLogo
      },
      showDialog: false,
      posters: {
        1: Poster1,
        2: Poster2,
        3: Poster3,
        4: Poster4,
        5: Poster5,
        6: Poster6,
        7: Poster7,
        8: Poster8,
        9: Poster9
      }
    });

    const closeDialog = () => {
      state.showDialog = false;
    }



    return {
      ...toRefs(state),
      closeDialog
    };
  }
}
</script>

<style scoped>
.company-main {
  background-color: #001E54;
  padding-bottom: 10rem;
  height: 100vh;
}

.company-main-logo {
  width: calc(872px / 2.5);
  position: relative;
  top: 2rem;
  left: calc((100% - 872px / 2.5) / 2);
}

.company-main-title {
  background-image: linear-gradient(to right, #cadef2, #1e9ad5);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  font-size: 25px;
  font-weight: bold;
  letter-spacing: 0.1rem;
  width: 90%;
  position: relative;
  left: calc((100% - 90%) / 2);
  top: 4rem;
}

.company-main-desc {
  color: white;
  position: relative;
  top: 5rem;
  width: 90%;
  left: calc((100% - 90%) / 2);
  line-height: 1.5rem;
  letter-spacing: 0.1rem;
}
</style>